module.exports = __webpack_public_path__ + "img/Liza.2e26ab9a.png";